import React, { useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import Api from "@/_helpers/Api"
import { trans } from "@/_providers/Translation"
import { LineChart } from "@mui/x-charts"
import moment from "moment"

function CLVForecast() {
  const [loading, setLoading] = useState(true)
  const [labels, setLabels] = useState([])
  const [historical, setHistorical] = useState([])
  const [predicted, setPredicted] = useState([])
  const [customers, setCustomers] = useState([])
  const [filters, setFilters] = useState({ customer_id: "" })

  useEffect(() => {
    loadData()
  }, [filters])

  function loadData() {
    setLoading(true)

    Api.get(`analytics/predicted-clv?customer_id=${filters.customer_id}`)
      .then((res) => {
        setLabels(
          res.data.chart_data.labels?.map((date) => {
            return moment(date, "YYYY-MM").isSame(moment(), "month")
              ? "Днес"
              : moment(date, "YYYY-MM").format("MM.YYYY")
          }) || [],
        )
        setHistorical(res.data.chart_data.historical || [])
        setPredicted(res.data.chart_data.predicted || [])
        setCustomers(res.data.customers || [])

        setLoading(false)
      })
      .catch(() => setLoading(false))
  }

  const historicalSeries = labels.map((_, i) =>
    i < historical.length ? (historical[i] ?? null) : null,
  )

  const boundaryIndex = historical.length - 1
  const predictedSeries = labels.map((_, i) => {
    if (i === boundaryIndex) return historical[boundaryIndex] ?? null
    if (i > boundaryIndex) return predicted[i - historical.length] ?? null
    return null
  })

  function hasAnyData() {
    return labels.length > 0
  }

  function handleFilterChange(e) {
    const { name, value } = e.target

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  return (
    <div className="customers-chart">
      <div className="head">
        <h3>{trans("analytics.clvForecast")}</h3>
        <div className="right">
          {loading ? (
            <Skeleton height={40} width={140} count={1} />
          ) : (
            <select
              value={filters.customer_id || ""}
              name="customer_id"
              onChange={handleFilterChange}
            >
              {customers.map((customer) => (
                <option key={customer.id} value={customer.id}>
                  {customer.name}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>
      <hr />
      {loading ? (
        <Skeleton height={300} count={1} />
      ) : !hasAnyData() ? (
        <div
          className="alert info"
          style={{
            marginBottom: 0,
            width: "100%",
          }}
        >
          {trans("messages.noDataFound")}
        </div>
      ) : (
        <LineChart
          xAxis={[{ scaleType: "point", data: labels }]}
          series={[
            {
              label: "Исторически данни",
              area: true,
              data: historicalSeries,
              color: "#9ba9dd",
              valueFormatter: (v) => (v == null ? "" : String(v)),
            },
            {
              label: "Прогноза",
              data: predictedSeries,
              area: true,
              color: "#bec6e1",
              valueFormatter: (v) => (v == null ? "" : String(v)),
            },
          ]}
          height={295}
          sx={{
            "& .MuiLineElement-root": { strokeWidth: 1 },
          }}
          slotProps={{
            legend: { hidden: true },
          }}
        />
      )}
    </div>
  )
}

export default CLVForecast
